import './ProductImage.css';

const ProductImage = ({
  imgSrc = "/images/Cadillac_Logo_Black.png",
    imgAlt = "Product Image"
}) => {
    return (
        <div className="product-image">
            <img src={imgSrc} alt={imgAlt} />
        </div>
    );
};

export default ProductImage;
